import styled from 'styled-components';
import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
} from '@oneaudi/unified-web-common';

// hsl(0, 0.00%, 94.90%)
export const VehicleLocationWrapper = styled.div`
  background-color: #f2f2f2;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 34px;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    height: 72px;
  }
`;

export const Text = styled.p`
  font-family: 'Audi Type';
  font-size: 12px;
  line-height: 15px;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const VehicleDetailsPageWrapper = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;
  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    width: calc(100% - 56px);
    margin: 0 auto;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: calc(100% - 120px);
    margin: 0 auto;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: calc(100% - 192px);
    margin: 0 auto;
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    max-width: 1248px;
    margin: 0 auto;
  }
`;
